import apiClient from "../common/apiClient";

export default class MedicalFeeDetailController {
    async Create(data, token) {
        try {
            return await apiClient.post("/medical-feeDetail/", data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async Update(data, token) {
        try {
            return await apiClient.put("/medical-feeDetail/", data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async Delete(id, token) {
        try {
            return await apiClient.delete("/medical-feeDetail/" + id, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async GetAllFeeDetail(token) {
        try {
            return await apiClient.get("/medical-getAllfeeDetail/", {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }
}
